import { getServiceType } from '../../../../../../helpers/getters';
import { checkProviderServiceSubscription, checkModalSubscription, getSelectedService } from '../../../helper';
import { store } from '../../../../../../../../../store';

export default (form, providerForm, modal) => {
  const { provider_service_id, provider_id, service_type, mode } = form;
  const { serviceTypes } = store.getState().services;

  if (mode) {
    /**
     * Если выбранный сервис subscription
     * drip_feed убираем
     */
    const isModalSubscription = checkModalSubscription(modal);
    const isSubscription = checkProviderServiceSubscription(form, providerForm);
    if (isSubscription || isModalSubscription) {
      return false;
    }
    /**
     * Сначала проверяем сервис, потом провайдера
     */
    if (provider_service_id) {
      const selectedService = getSelectedService(provider_service_id, providerForm);
      if (selectedService?.hasOwnProperty('service_type')) {
        const findServiceType = serviceTypes.find((serviceType) => Number(serviceType.id) === Number(selectedService.service_type));
        if (findServiceType) {
          if (findServiceType.hasOwnProperty('dripfeed')) {
            return findServiceType.dripfeed;
          }
        }
      }
    }
    /**
     * Если есть provider_service_id ждем пока его выберут
     */
    if (providerForm?.hasOwnProperty('provider_service_id') && !provider_service_id) {
      return false;
    }
    if (provider_id) {
      const findDefaultServiceType = serviceTypes.find((serviceType) => serviceType.id === 0);
      if (findDefaultServiceType) {
        if (findDefaultServiceType.hasOwnProperty('dripfeed')) {
          return findDefaultServiceType.dripfeed;
        }
      }
    }
  } else {
    const serviceType = getServiceType(service_type);
    if (serviceType && serviceType?.hasOwnProperty('dripfeed')) {
      return serviceType.dripfeed;
    }
  }
  return false;
};
